import type { ActType, StoreModelType } from "../types/globalStore.types";
import navigationData from "./navigation.json";

export const initialState: StoreModelType = {
  currentScreen: navigationData.startScene,
  acts: navigationData.initialActs as ActType[],
  hasFinalized: false,
  hasStarted: false,
};
